import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { ServiceDto } from "@/core/features/services/service.dto";
import { CreateServiceDto } from "@/core/features/services/create-service.dto";
import { UpdateServiceDto } from "@/core/features/services/update-service.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { merge } from "lodash";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ServicesResource extends ResourceBaseService<ServiceDto, CreateServiceDto, UpdateServiceDto> {
  protected EntityDto = ServiceDto;
  protected CreateEntityDto = CreateServiceDto;
  protected UpdateEntityDto = UpdateServiceDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/services");
  }

  async optionLoader(inputValue: string, customRequest: IRequest = {}): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "code", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(merge(request, customRequest)));
    return data.map((value) => value.mapEntityToOptionType([value.toString()]));
  }
}
